import { createContext as t } from "react";
const o = t({
  colorVariant: "primary",
  styleVariant: "tab"
});
export {
  o as default
};
